import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';

export default function LaserHairRemoval() {
    const { t } = useTranslation();
    const accodirons = [
        {
            title: 'What it is?',
            content: 'Precise ablation at the surface plus controlled dermal heat stimulates collagen remodeling and new skin formation'
        },
        {
            title: 'How it works',
            content: 'Precise ablation at the surface plus controlled dermal heat stimulates collagen remodeling and new skin formation'
        },
    ];

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: '10 to 60 min per area'
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: 'Mild snapping with cooling'
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: 'None'
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: '6 to 8 spaced 4 to 8 weeks'
        }
    ];

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                       
                        <Box component={'img'} alt='' src={`${process.env.REACT_APP_API_URL}/images/2025/12/Lutronic_Hair-Removal.png`} width={1} height={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    // titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: t('bodyherapies'),
                        title: "Laser Hair Removal",
                        description: "Silky smooth skin, forever. Ditch the razor and wax our medical-grade laser hair removal offers a lasting solution for unwanted hair, giving you soft, hair-reduced skin with minimal effort.",
                        bookUrl: "/",
                        learn: ""
                    }}
                />
            </Box>

            <Box  marginTop={{md: '117px', xs: '50px'}}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{md: '144px', xs: '50px'}} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Grid container spacing={4} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{md: '120px', xs: '50px'}}>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto' }} mt={{md: '136px', xs: '50px'}}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: '/',
                            type: 'Technology',
                            learn: '/',
                            title: 'Lutronic Clarity II',
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 12, xs: 12 },
                            // imageUrl: "/images/Mask_Group_42.png",
                            // flexDirection: {md: 'row-reverse', xs: 'row'},
                            description: 'Clarity II combines Alexandrite 755 nm and Nd:YAG 1064 nm wavelengths to target pigment, vessels, and hair with exceptional precision. Its high-speed scanning and real-time cooling ensure safe, uniform results on every skin type. A reliable solution for vascular lesions, rosacea, pigmentation, and rejuvenation.'
                        }}
                        extraStyle={{background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'}}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>

            <Grid container className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{md: '57px', xs: '50px'}} gap={{ md: '80px', xs: '30px' }} mb={{md: '135px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>
        </Box>
    )
}